export class RateUnit {
  unitInc: number = null;
  fee: number = null;
};